export default {
  ok: 'ok',
  failed: 'failed',
};
